import React from 'react';

function EULA() {
  return (
    <div className="terms-container" style={{ padding: '1rem', maxWidth: 900, margin: 'auto' }}>
      <header className="terms-header">
        <h1>END USER LICENSE AGREEMENT</h1>
        <p><strong>Big Circle Auctions LLC</strong></p>
      </header>

      <section className="terms-content" style={{ lineHeight: 1.6 }}>
        <p>
          This End User License Agreement (“Agreement”) is entered into by and between Big Circle Auctions LLC,
          a limited liability company organized in the State of Michigan with its registered office
          414 S Main Street #201 Rochester, MI 48307 (“BCA”, “we”, “us”, or “our”), and you.
        </p>

        <h2>1. Definitions</h2>
        <p><strong>Platform</strong> means the proprietary digital environment operated by BCA.</p>
        <p><strong>Service Fee</strong> means payment for access to the Platform.</p>
        <p><strong>Access Rights</strong> means your limited right to use the Platform.</p>

        <h2>2. License Grant</h2>
        <p>
          BCA grants a limited, non-exclusive, non-transferable, revocable license for participation in the
          paid auction round only.
        </p>

        <h2>3. Scope of Use</h2>
        <ul>
          <li>No resale or sharing of access.</li>
          <li>No copying or reverse engineering.</li>
          <li>No fraud or unlawful use.</li>
          <li>No interference with systems.</li>
        </ul>

        <h2>5. Service Fee</h2>
        <p>
          Service fees grant platform access only and are non-refundable once access is provided.
        </p>

        <h2>12. Governing Law</h2>
        <p>
          This Agreement is governed by the laws of the State of Michigan and Oakland County.
        </p>

        <h2>13. Contact</h2>
        <p>
          Big Circle Auctions LLC<br />
          contact@bigcircleauctions.com<br />
          414 S Main Street #201 Rochester, MI 48307
        </p>
      </section>
    </div>
  );
}

export default EULA;
